










































































































































import { Component, Vue } from "vue-property-decorator";
import { FIRE, DB } from "../settings/CONST_REFS";
import { transformData, UserType } from "../services/firebaseAuths";
//import axios from "axios";

@Component({
  name: "dashboard",
  components: {
    // sub-components
  },
})
export default class Dashboard extends Vue {
  private items: any[] = ["Names", "Dates"];
  private value: any[] = ["Roberto Santos", "	01/12/2020"];
  private campaigns: any[] = ["VIVO", "SHELL"];
  private campaign: any[] = ["Vivo", "Shell"];
  private singleSelect = false;
  private selected: any[] = [];
  private headers: any[] = [
    { text: "PICTURE", align: "right", sortable: false, value: "avatar" },
    { text: "NAMES", align: "left", sortable: false, value: "name" },
    { text: "DATE", value: "applied" },
    { text: "PROGRESS", value: "progress" },
    { text: "RATING", value: "rating" },
    { text: "", value: "action", sortable: false },
  ];
  private desserts = [{}];
  private access: any = "";
  private user: any = "";

  created() {
    this.initialize();
  }

  mounted() {
    this.getAccess();
    this.checkingUserData();
    this.persistUserLS();
    this.getSessions();
  }

  on() {
    console.log("This on was pressed 😁");
  }

  initialize() {
    this.desserts = [
      {
        avatar: "https://randomuser.me/api/portraits/women/10.jpg",
        name: "Karla Daishi",
        applied: "10/12/2020",
        progress: 85,
        rating: 4,
      },
      {
        avatar: "https://randomuser.me/api/portraits/women/13.jpg",
        name: "Sophia Seppia",
        applied: "10/12/2020",
        progress: 79,
        rating: 5,
      },
      {
        avatar: "https://randomuser.me/api/portraits/men/17.jpg",
        name: "Roberto Santos",
        applied: "01/12/2020",
        progress: 80,
        rating: 3,
      },
      {
        avatar: "https://randomuser.me/api/portraits/women/5.jpg",
        name: "Arys Trite",
        applied: "10/12/2020",
        progress: 85,
        rating: 4,
      },
      {
        avatar: "https://randomuser.me/api/portraits/men/22.jpg",
        name: "Haldo Daichi",
        applied: "10/12/2020",
        progress: 90,
        rating: 3,
      },
      {
        avatar: "https://randomuser.me/api/portraits/women/12.jpg",
        name: "Karla Itadachi",
        applied: "10/12/2020",
        progress: 85,
        rating: 4,
      },
      {
        avatar: "https://randomuser.me/api/portraits/men/10.jpg",
        name: "Fulanguen Strepi",
        applied: "10/12/2020",
        progress: 90,
        rating: 5,
      },
      {
        avatar: "https://randomuser.me/api/portraits/women/19.jpg",
        name: "Misako Daishi",
        applied: "10/12/2020",
        progress: 95,
        rating: 5,
      },
      {
        avatar: "https://randomuser.me/api/portraits/men/12.jpg",
        name: "Ivere Atio",
        applied: "10/12/2020",
        progress: 75,
        rating: 3,
      },
      {
        avatar: "https://randomuser.me/api/portraits/women/14.jpg",
        name: "Imari Houske",
        applied: "10/12/2020",
        progress: 85,
        rating: 4,
      },
      {
        avatar: "https://randomuser.me/api/portraits/women/18.jpg",
        name: "Nixoann Maishi",
        applied: "10/12/2020",
        progress: 60,
        rating: 4,
      },
      {
        avatar: "https://randomuser.me/api/portraits/women/10.jpg",
        name: "Leifra Nasake",
        applied: "10/12/2020",
        progress: 98,
        rating: 5,
      },
    ];
  }

  public async checkingUserData() {
    const info = await FIRE.auth().currentUser;
    // console.log("this is the user info -> ", info);
    const user: UserType = transformData(info);
    // console.log("this is the user user -> ", user);
    if (user) {
      this.user = user;
      // console.log("Se paso.. ", user);
    }
  }

  public persistUserLS() {
    if (this.user) {
      localStorage.user = this.user;
    }
  }

  public async getSessions(){
    const sessions = [{ }]
    
    await DB.collection("user")
    .doc("events")
    .collection("sessions")
    .get()
    .then((res: any) => {
      // console.log("Session save it successfuly!");
      // console.log("Res -> ", res);

      return sessions.push(res);
    })
    .catch((err: Error) => {
      console.log("Error: ", err);
      console.log("Error Message: Saving this session: ", err.message);
      return err;
    });    
    // const strSessions = JSON.stringify(sessions);
    // console.log("This is de list of sessions",  strSessions);
  }

  public async getAccess() {
    const token = await FIRE.auth().currentUser!.getIdToken();
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    // const response = await axios.get("http://localhost:3000/Zero", config);
    // this.access = response.data;
  }
}
